import React, { useEffect } from 'react';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import CourseStructureSection from '../components/landing/CourseStructureSection';
import CourseGoals from '../components/landing/CourseGoals';
import AboutSection from '../components/landing/AboutSection';
import ProgramSection from '../components/landing/ProgramSection';
import ModulesSection from '../components/landing/ModulesSection';
import StudentResultsSection from '../components/landing/StudentResultsSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import FAQSection from '../components/landing/FAQSection';
import PricingSection from '../components/landing/PricingSection';
import Footer from '../components/landing/Footer';

const LandingPage = ({ discountMode = false }) => {
  // Auto-scroll to #pricing when arriving via a discount link.
  // Retries multiple times because images above pricing keep loading and shift
  // the section downward on slow mobile networks.
  useEffect(() => {
    if (!discountMode) return undefined;
    if (window.location.hash) return undefined; // let browser handle explicit hash

    let cancelled = false;
    const scrollToPricing = () => {
      const el = document.getElementById('pricing');
      if (!el) return false;
      // Account for any fixed/sticky header by computing absolute Y manually
      const rect = el.getBoundingClientRect();
      const targetY = window.scrollY + rect.top - 8;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
      return true;
    };

    // First attempt almost immediately
    const timers = [];
    [120, 600, 1500, 3000, 5000].forEach((delay) => {
      const t = setTimeout(() => { if (!cancelled) scrollToPricing(); }, delay);
      timers.push(t);
    });

    // Also re-scroll once the window finishes loading (images, fonts)
    const onLoad = () => { if (!cancelled) scrollToPricing(); };
    if (document.readyState === 'complete') {
      // Already loaded — extra nudge
      setTimeout(onLoad, 200);
    } else {
      window.addEventListener('load', onLoad, { once: true });
    }

    return () => {
      cancelled = true;
      timers.forEach(clearTimeout);
      window.removeEventListener('load', onLoad);
    };
  }, [discountMode]);

  return (
    <div className="min-h-screen bg-[#050506] pb-14 xl:pb-0">
      <Header />
      <main>
        <HeroSection />
        <HowItWorksSection />
        <CourseStructureSection />
        <AboutSection />
        <CourseGoals />
        <ProgramSection />
        <ModulesSection />
        <StudentResultsSection />
        <TestimonialsSection />
        <FAQSection />
        <PricingSection discountMode={discountMode} />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
